import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { LOG_CLUSTER_LANGUAGES } from "../../../../../../data/constants";
import { CloseIcon, InfoIcon } from "../../../../../Icons";
import { IconButton, Modal } from "../../../../../UI";
import { StyledButton } from "../../../../../UI/Button/Button-styled";
import {
  StyledIframe,
  StyledIframeContainer,
  StyledModalContainer,
  StyledModalHeader,
} from "../Support-styled";

const AboutModal = ({ show, handleClose }) => {
  const iframeRef = useRef(null);
  const [muted, setMuted] = useState(true);
  const { t, i18n } = useTranslation("common");

  const switchLogClusterLanguage = () => {
    if (LOG_CLUSTER_LANGUAGES.includes(i18n.language)) {
      return i18n.language;
    } else {
      return "en";
    }
  };

  const handleClickMore = () => {
    const url = `https://logcluster.org/${switchLogClusterLanguage()}/node/42096`;
    if (iframeRef.current?.contentWindow?.postMessage) {
      iframeRef.current.contentWindow?.postMessage(
        '{"event":"command","func":"pauseVideo","args":""}',
        "*"
      );
    }

    window.open(url, "_blank");
  };

  return (
    <Modal show={show}>
      <StyledModalContainer>
        <StyledModalHeader>
          <h2
            style={{
              margin: 0,
              marginBottom: 0,
              fontSize: "var(--fontSizeTitle)",
              fontWeight: 400,
              textAlign: "left",
              // width: "100%",
              display: "flex",
              alignItems: "center",
              gap: 2,
              color: "var(--fontColor)",
            }}
          >
            <InfoIcon fill="var(--fontColor)" width="22px" height="22px" />
            {t("screen.widget.Support.about.title")}
          </h2>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </StyledModalHeader>
        <StyledIframeContainer>
          <StyledIframe
            id="about-youtube-iframe"
            ref={iframeRef}
            src="https://www.youtube-nocookie.com/embed/SgEAEveF9qY?si=xW7oVY91tO6ueAt2&autoplay=1&controls=0&disablekb=1&modestbranding=0&fs=0&cc_load_policy=1&loop=1&mute=0&rel=0&enablejsapi=1"
            title="YouTube video player"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen={false}
          />
        </StyledIframeContainer>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            justifyContent: "center",
            fontSize: 19,
            color: "var(--fontColor)",
          }}
        >
          <span>{t("screen.widget.Support.about.wantToKnowMore")}</span>
          <div style={{ display: "flex", gap: "14px" }}>
            <StyledButton
              style={{
                color: "rgb(73,73,73)",
                padding: "4px 12px",
                background: "rgba(0,0,0,0.08)",
                borderRadius: "8px",
                fontWeight: 400,
              }}
              onClick={handleClickMore}
            >
              <span>{t("screen.actions.clickHere")}</span>
            </StyledButton>
          </div>
        </div>
      </StyledModalContainer>
    </Modal>
  );
};

export default AboutModal;
